import React from "react";
import { Link } from "react-router-dom";
import app from "../../base";
import * as firebase from "firebase/app";
import "firebase/storage";
import { Layout } from "antd";
import NavBar from "../Header";
import KakiKaki from "../Footer";
import { Card, Col, Row } from "antd";
import mapboxgl from "mapbox-gl";
import "./DetailRental.css";
import axios from "axios";

mapboxgl.accessToken =
  "pk.eyJ1IjoibWFya2RleCIsImEiOiJjazl2anl0ZGgwODB4M25wa2xobmQxa3JoIn0.IRlo423Q24Y2Hgh0P7xLtw";

const { Header, Footer, Content } = Layout;

class DetailRentalCard extends React.Component {
  mapRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      rental: {},
      key: "",
      img: null,
      lng: 110.3824293,
      lat: -7.7938307,
      zoom: 13,
    };
  }

   componentDidMount() {
     
    const url = `api.openweathermap.org/data/2.5/weather`
    const appid = `69db624d6768601eeb046d6a847ee587`
    axios.get(`${url}?q=${this.state.rental.city}&appid=${appid}`)
    .then(res=>{
      console.log(res)
      const cuaca = res.data;
      console.log(cuaca)
      this.setState({cuaca})
    })
  
    const ref = app
      .firestore()
      .collection("rentals")
      .doc(this.props.match.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          rental: doc.data(),
          key: doc.id,
          isLoading: false,
        });
      } else {
        console.log("No such document!");
      }
    });

    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [this.state.lng, this.state.lat],
      zoom: this.state.zoom,
      minZoom: 12
      
    });

    var marker = new mapboxgl.Marker()
      .setLngLat([this.state.lng, this.state.lat])
      .addTo(map);
      
   }
  render() {
    const { lng, lat, zoom, city,weather,temp } = this.state;
    return (
      <Layout>
        <Header>
          <NavBar />
        </Header>
        <Content>
          <div className="rentalan">
            <div className="site-card-wrapper">
              <Card className="card-content">
                <div>
                  <h2>{this.state.rental.rental_name}</h2>
                </div>
                <Row>
                  <Col span={12}>
                    <img
                    className="image-rental"
                      src={this.state.rental.imgUrl}
                      style={{ height: 400 }}
                    ></img>
                  </Col>
                  <Col span={12} className="detail-content">
                    <h4>Alamat</h4>
                    <p>{this.state.rental.address}</p>
                    <h4>Kontak</h4>
                    <p>{this.state.rental.phone}</p>
                    <h4>Kota</h4>
                    <p>{this.state.rental.city}</p>
                    <h4>Keadaan</h4>
                     <p>{this.state.weather}</p>
                  </Col>
                </Row>
                <br/>
                <br/>
                  <div className="inline-block absolute top left mt12 ml12 bg-darken75 color-white z1 py6 px12 round-full txt-s txt-bold">
                    <div>{`Longitude: ${lng} Latitude: ${lat} Zoom: ${zoom}`}</div>
                  </div>
                  <div
                    ref={(el) => (this.mapContainer = el)}
                    className="mapContainer"
                    style={{height:400}}
                  />
              </Card>
            </div>
          </div>
        </Content>
        <Footer style={{ background: "#7F7CAF" }}>
          <KakiKaki />
        </Footer>
      </Layout>
    );
  }
}

export default DetailRentalCard;
